export const TOKEN_KEY = 'PCS_JWT_TOKEN';
export const AUTHORIZATION_HEADER_NAME = 'X-Authorization';

export const CSRF_HEADER_NAME = 'X-CSRF-TOKEN';
export const CSRF_COOKIE_NAME = 'CSRF-TOKEN';
